import i18n from '@/plugins/i18n';

const NOTIFICATION_EVENT_TYPES = {
  PRE_VENDA: 'preVenda',
  PRE_VENDA_UPPER: 'PRE_VENDA',
  PRE_VENDA_EXTERNA: 'preVendaExterna',
  PRE_VENDA_CLIENTE: 'preVendaCliente',
  PRE_VENDA_DOLSPAY: 'preVendaDolsPay',
  FICHA_ASSINADA: 'fichaAssinada',
  FICHA_ASSINADA_UPPER: 'FICHA_ASSINADA',
  RECEIVER_ENVIADO: 'receiverEnviado',
  RECEIVER_APROVADO: 'receiverAprovado',
  RECEIVER_PENDENTE: 'receiverPendente',
  RECEIVER_FALHA: 'receiverFalha',
  DUIMP_ATUALIZADO: 'duimpAtualizado',
  STATUS_BANCARIO: 'bankOnboardingStatusChanged',
  RFI_COMPLIANCE: 'rfiCompliance',
  LIMITE_AUMENTO: 'limiteAumento',
  COMISSAO_URGENTE: 'comissaoUrgente',
  COBRANCA_DUIMP_PENDENTE: 'cobrancaDuimpPendente'
};

const NOTIFICATION_BADGE_TEXTS = {
  get OPERACAO_EXTERNA() { return i18n.t('notificationHistory.notificationBadgesUi.externalOperation'); },
  get OPERACAO_CLIENTE() { return i18n.t('notificationHistory.notificationBadgesUi.customerOperation'); },
  OPERACAO_DOLSPAY: 'DolsPay',
  get FICHA_ASSINADA() { return i18n.t('notificationHistory.notificationBadgesUi.signedForm'); },
  get PRE_VENDA() { return i18n.t('notificationHistory.notificationBadgesUi.preSale'); },
  get FICHA_CADASTRAL() { return i18n.t('notificationHistory.notificationBadgesUi.signedRegistrationForm'); },
  get NOTIFICACAO() { return i18n.t('notificationHistory.notificationBadgesUi.notification'); },
  get RECEIVER_ENVIADO() { return i18n.t('notificationHistory.notificationBadgesUi.registrationSent'); },
  get RECEIVER_APROVADO() { return i18n.t('notificationHistory.notificationBadgesUi.registrationApproved'); },
  get RECEIVER_PENDENTE() { return i18n.t('notificationHistory.notificationBadgesUi.registrationPending'); },
  get RECEIVER_FALHA() { return i18n.t('notificationHistory.notificationBadgesUi.registrationFailed'); },
  get DUIMP_ATUALIZADO() { return i18n.t('notificationHistory.notificationBadgesUi.duimpUpdated'); },
  get STATUS_BANCARIO() { return i18n.t('notificationHistory.notificationBadgesUi.bankStatus'); },
  RFI_COMPLIANCE: 'Compliance',
  get LIMITE_AUMENTO() { return i18n.t('notificationHistory.notificationBadgesUi.limitIncrease'); },
  get COMISSAO_URGENTE() { return i18n.t('notificationHistory.notificationBadgesUi.urgentCommission'); },
  get COBRANCA_DUIMP_PENDENTE() { return i18n.t('notificationHistory.notificationBadgesUi.duimpChargePending'); }
};

/*
 * Tom semântico do evento — NÃO cor. O componente resolve para os tokens
 * `--tc-*` correspondentes, então a paleta acompanha tenant e tema sozinha.
 *
 * As cores Material que viviam aqui ('deep-purple', 'blue lighten-3') são
 * anti-padrão do design system: não existem nos tokens, não mudam com o
 * tenant e quebram o contraste no tema escuro.
 *
 * action  — exige atenção operacional   success — concluído
 * warning — pendência do cliente        danger  — falhou
 * info    — informativo, sem ação
 */
const NOTIFICATION_TONES = {
  [NOTIFICATION_EVENT_TYPES.PRE_VENDA]: 'action',
  [NOTIFICATION_EVENT_TYPES.PRE_VENDA_UPPER]: 'action',
  [NOTIFICATION_EVENT_TYPES.PRE_VENDA_EXTERNA]: 'action',
  [NOTIFICATION_EVENT_TYPES.PRE_VENDA_CLIENTE]: 'action',
  [NOTIFICATION_EVENT_TYPES.PRE_VENDA_DOLSPAY]: 'info',
  [NOTIFICATION_EVENT_TYPES.FICHA_ASSINADA]: 'success',
  [NOTIFICATION_EVENT_TYPES.FICHA_ASSINADA_UPPER]: 'success',
  [NOTIFICATION_EVENT_TYPES.RECEIVER_ENVIADO]: 'info',
  [NOTIFICATION_EVENT_TYPES.RECEIVER_APROVADO]: 'success',
  [NOTIFICATION_EVENT_TYPES.RECEIVER_PENDENTE]: 'warning',
  [NOTIFICATION_EVENT_TYPES.RECEIVER_FALHA]: 'danger',
  [NOTIFICATION_EVENT_TYPES.DUIMP_ATUALIZADO]: 'info',
  [NOTIFICATION_EVENT_TYPES.STATUS_BANCARIO]: 'info',
  [NOTIFICATION_EVENT_TYPES.RFI_COMPLIANCE]: 'warning',
  [NOTIFICATION_EVENT_TYPES.LIMITE_AUMENTO]: 'info',
  [NOTIFICATION_EVENT_TYPES.COMISSAO_URGENTE]: 'warning',
  [NOTIFICATION_EVENT_TYPES.COBRANCA_DUIMP_PENDENTE]: 'warning'
};

const NOTIFICATION_TAB_PARAMETERS = {
  INTERNAS: 'internas',
  EXTERNAS: 'externas',
  CLIENTES: 'clientes',
  DOLSPAY: 'dolspay'
};

const PRE_SALE_TAB_INDEXES = {
  INTERNAS: 0,
  EXTERNAS: 1,
  CLIENTES: 2,
  DOLSPAY: 3
};

export {
  NOTIFICATION_EVENT_TYPES,
  NOTIFICATION_BADGE_TEXTS,
  NOTIFICATION_TONES,
  NOTIFICATION_TAB_PARAMETERS,
  PRE_SALE_TAB_INDEXES
};
